'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeAssert;

var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Given a message string (e.g. 'Validation failed'), return an assert function
 * which includes that message, and returns true if the assertion does not
 * throw an error.
 */
function makeAssert() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Assertion failed';

  return function (assertion, reason) {
    (0, _assert2.default)(assertion, message + ': ' + reason);
    return true;
  };
}
//# sourceMappingURL=makeAssert.js.map